<template>
  <el-dialog title="编辑站点" :visible.sync="visible" @opened="openDialog" class="temperatureDialog" @close="closeDialog"
    :modal-append-to-body="false" :close-on-click-modal="false" :class="visible ? 'flip-in-hor-bottom' : ''">
    <div>
      <div>
        <el-form label-position="left" label-width="7rem" :model="form1" style="display: flex" :rules="rules"
          ref="ruleForm">
          <el-form-item label="站点名：" prop="name">
            <el-input v-model="form1.name"></el-input>
          </el-form-item>
        </el-form>

        <div style="text-align: right">
          <button class="btn3" @click="edit('ruleForm')">确定</button>
          <button style="margin-left: 24px;" class="btn4" @click="closeDialog">取消</button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import commonUtils from "@/utils/common";
import datePicker from "@/components/datePicker.vue";
import Pagination from "@/components/Pagination.vue";
export default {
  components: { datePicker, Pagination },
  data() {
    return {
      activeTab: "表格1", // 当前选中的选项卡
      activeStep: 0,
      visible: false,
      lineChartDataX: [],
      lineChartDataY: [],
      lightedPoint: [],
      form1: {
        name: '',
      },
      rules: {
        remark: [{ required: false }],
        name: [{ required: true, message: "请输入站点名", trigger: "blur" }],
        windId: [
          { required: true, message: "请指定关联设备", trigger: "change" },
        ],
        frp: [{ required: false }],
      },
      value1: new Date(),
      maxTime: commonUtils.timeFormat(new Date()),
      minTime: commonUtils.timeFormat(
        new Date(new Date().getTime() - 3600 * 24 * 1000)
      ),
      dateValue: [
        commonUtils.timeFormat(
          new Date(new Date().getTime() - 3600 * 24 * 1000)
        ),
        commonUtils.timeFormat(new Date()),
      ],
      options: [
        {
          value: "选项1",
          label: "重要",
        },
      ],

      total: 100,
      pageNo: 1,
      pageSize: 10,
      row: "",
    };
  },
  methods: {
    edit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            name: this.form1.name,
            id: this.form1.id,
          };
          this.$api.elevator.updateSite(params).then((res) => {
            if (res.code == 200) {
              this.$emit("getSiteList");
              this.$alert("修改站点信息成功", "", {
                confirmButtonText: "确定",
                type: "success",
                center: true,
              }).then((action) => {
                if (action === "confirm") {
                  this.visible = false;
                }
              });
            } else {
              this.$alert(res.msg, "", {
                confirmButtonText: "确定",
                type: "warning",
                center: true,
              }).then((action) => {
                if (action === "confirm") {
                  this.visible = false;
                }
              });
            }
          });
        } else {
          this.$alert("请将参数填写完整", "", {
            confirmButtonText: "确定",
            type: "warning",
            center: true,
          }).then((action) => {
            if (action === "confirm") {
              this.visible = false;
            }
          });
          return false;
        }
      });
    },
    // nextStep() { // 下一步按钮点击事件处理函数
    //   if (this.activeStep < 3) {
    //     this.activeStep += 1;
    //     this.activeTab = `表格${this.activeStep + 1}`; // 切换到下一个选项卡
    //     if (this.activeStep == 3)
    //     { this.activeStep = 0;}
    //   }},

    openDialog() { },
    closeDialog() {
      this.visible = false;
    },
    //选择时间
    confirmDate(min, max) {
      if (min) {
        //选择时间
        this.maxTime = max;
        this.minTime = min;
      } else {
        //清空时间，取默认
        this.dateValue = [
          new Date(new Date().getTime() - 3600 * 24 * 1000),
          new Date(),
        ];

        this.maxTime = commonUtils.timeFormat(new Date());
        this.minTime = commonUtils.timeFormat(
          new Date(new Date().getTime() - 3600 * 24 * 1000)
        );
      }
    },
  },
};
</script>


<style lang="less" scoped>
.temperatureDialog {
  /deep/ .el-input {
    width: 12rem;
    margin-right: 24px;
  }

  /deep/ .el-input__inner {
    height: 32px;
    background: #E5E5E520 !important;
    border: 1px solid #E5E5E520 !important;
    color: #44D7B6;
  }

  /deep/.el-textarea__inner {
    width: 12rem;
    background: #E5E5E520 !important;
    border-radius: 4px;
    border: 1px solid #E5E5E520 !important;
    color: #44D7B6;
  }

  /deep/ .el-select {
    width: 13.4375rem;
  }

  /deep/ .el-select-dropdown__wrap.el-scrollbar__wrap {
    overflow: auto;
    background-color: #244447;
    border: none;
  }

  /deep/ .el-select-dropdown {
    border: none;
  }

  /deep/ .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    color: #d3fbff;
    background-color: #3f98a0;
  }

  /deep/ .el-select-dropdown__item.selected {
    color: #d3fbff;
  }

  /deep/ .el-select-dropdown__item {
    color: rgba(255, 255, 255, 0.603);
  }

  /deep/ .el-form-item__label {
    color: #b4b4b4;
    font-size: 0.875rem;
  }

  /deep/ .pagination-container {
    text-align: center;
  }
}

//添加动画
.flip-in-hor-bottom {
  animation: flip-in-hor-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes flip-in-hor-bottom {
  0% {
    transform: rotateX(80deg);
    opacity: 0;
  }

  100% {
    transform: rotateX(0);
    opacity: 1;
  }
}

.pane-title {
  padding-left: 1.875rem;
  font-size: 1.3125rem;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #5bb3bc;
  line-height: 2rem;
}

.btn-1 {
  margin-left: 15px;
  width: 120px;
  height: 40px;
  background: #44d7b6;
  border-radius: 2px;
  color: #ffffff;
  border: none;
  cursor: pointer;
}

.btn3 {
  width: 8.125rem;
  height: 1.875rem;
  background: #219E82;
  border-radius: 0.125rem;
  border: 0.0625rem solid #219E82;
  color: white;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn3:hover {
  background: #44D7B6;
}
.btn4 {
  width: 8.125rem;
  height: 1.875rem;
  border-radius: 0.125rem;
  border: 0.0625rem solid #44D7B6;
  background: transparent;
  color: #44D7B6;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn4:hover {
  background: #44D7B655;
}
</style>


// WEBPACK FOOTER //
// src/pages/systemSet/siteManagement/editSiteDialog.vue